import { defineMessages } from 'react-intl';

export default defineMessages({
    noCoverage: {
        id: 'earenewal.bop.directives.bop-building-directive.No Coverages',
        defaultMessage: 'No Coverages'
    },
    selectedValue: {
        id: 'earenewal.The value must be between',
        defaultMessage: 'The value must be between {minValue} and {maxValue}'
    },
    minValue: {
        id: 'earenewal.The minimum allowed value is',
        defaultMessage: 'The minimum allowed value is {minValue}'
    },
    maxValue: {
        id: 'earenewal.The maximum allowed value is',
        defaultMessage: 'The maximum allowed value is {maxValue}'
    },
    updatingSelection: {
        id: 'earenewal.directives.coverages.Updating selection...',
        defaultMessage: 'Updating selection...'
    }
});
